import { useQuery } from '@tanstack/react-query'
import { trpc } from '~/lib/trpc'

export function useOrganisationByDomain(emailDomain: string | null) {
  return useQuery({
    ...trpc.admin.getOrganisationByDomain.queryOptions({
      emailDomain: emailDomain || '',
    }),
    enabled: !!emailDomain && emailDomain.length > 0,
  })
}
